module.exports = __webpack_public_path__ + "static/media/Upp_Main.3b44523d.png";